// extracted by mini-css-extract-plugin
module.exports = {"container":"LawyersMark__container___2yUGB","_active":"LawyersMark___active___1d0KH","content":"LawyersMark__content___1CZY8"};